import { Destinations } from "../nike";

export class SkechersCoLineRequestApi {

    poNumber?: string;
    exFactoryDate?: string;
    deliveryDate?: string;
    destinations?: Destinations[]

    constructor(
        poNumber?: string, remarks?: string, exFactoryDate?: string, deliveryDate?: string, destinations?: Destinations[]
    ) {
        this.poNumber = poNumber;
        this.exFactoryDate = exFactoryDate;
        this.deliveryDate = deliveryDate;
        this.destinations = destinations;
    }
}
